import { Component, OnInit, Input } from '@angular/core';
import { DataGridComponent } from '../data-grid/data-grid.component';

@Component({
  selector: 'ps-data-grid-selectable-column',
  templateUrl: './data-grid-selectable-column.component.html',
  styleUrls: ['./data-grid-selectable-column.component.css']
})
export class DataGridSelectableColumnComponent implements OnInit {

  @Input() model: any;
  @Input() grid: DataGridComponent;

  constructor() { }

  ngOnInit() {
  }

  get selected() {
    return this.grid.isSelected(this.model);
  }

  set selected(value: boolean) {
    this.grid.changeRowSelected(this.model, value);
  }
}
